import { addRoute } from "../shared/router";
import netflix from "./page.vue";

addRoute("/netflix", netflix);
